export enum HtmlElementId {
  TSH_PAGE_DASHBOARD = 'TSH_PAGE_DASHBOARD',
  TSH_PAGE_SETTINGS = 'TSH_PAGE_SETTINGS',
  TSH_PAGE_STATS = 'TSH_PAGE_STATS',
  TSH_PAGE_SETTING_PRIVACY = 'TSH_PAGE_SETTING_PRIVACY',
  TSH_PAGE_SETTING_CASSAINCLOUD = 'TSH_PAGE_SETTING_CASSAINCLOUD',
  TSH_PAGE_SETTING_MARKETPLACE = 'TSH_PAGE_SETTING_MARKETPLACE',
  TSH_PAGE_SETTING_VATS_LIST = 'TSH_PAGE_SETTING_VATS_LIST',
  TSH_PAGE_SETTING_RESOURCES_LIST = 'TSH_PAGE_SETTING_RESOURCES_LIST',
  TSH_PAGE_SETTING_POSITIONS_LIST = 'TSH_PAGE_SETTING_POSITIONS_LIST',
  TSH_PAGE_SETTING_CHARGECATEGORIES_LIST = 'TSH_PAGE_SETTING_CHARGECATEGORIES_LIST',
  TSH_PAGE_SETTING_RESOURCETYPES_LIST = 'TSH_PAGE_SETTING_RESOURCETYPES_LIST',
  TSH_PAGE_SETTINGS_IMAGE_GALLERY = 'TSH_PAGE_SETTINGS_IMAGE_GALLERY',
  TSH_PAGE_SETTINGS_USERROLES = 'TSH_PAGE_SETTINGS_USERROLES',
  TSH_PAGE_SETTINGS_EINVOICE = 'TSH_PAGE_SETTINGS_EINVOICE',
  TSH_PAGE_SETTINGS_PS = 'TSH_PAGE_SETTINGS_PS',
  TSH_PAGE_SETTINGS_ISTAT = 'TSH_PAGE_SETTINGS_ISTAT',
  TSH_PAGE_SETTINGS_CITYTAX = 'TSH_PAGE_SETTINGS_CITYTAX',
  TSH_PAGE_SETTINGS_FISCALGATEWAY = 'TSH_PAGE_SETTINGS_FISCALGATEWAY',
  TSH_PAGE_SETTINGS_TSPAY = 'TSH_PAGE_SETTINGS_TSPAY',
  TSH_PAGE_SETTINGS_BOOKINGENGINE = 'TSH_PAGE_SETTINGS_BOOKINGENGINE',
  TSH_PAGE_SETTINGS_BOOKINGPOLICY_LIST = 'TSH_PAGE_SETTINGS_BOOKINGPOLICY_LIST',
  TSH_PAGE_SETTINGS_MAILTEMPLATES_LIST = 'TSH_PAGE_SETTINGS_MAILTEMPLATES_LIST',
  TSH_PAGE_SETTINGS_MAILTEMPLATES_VERSION_LIST = 'TSH_PAGE_SETTINGS_MAILTEMPLATES_VERSION_LIST',
  TSH_PAGE_SETTINGS_MAILTEMPLATE = 'TSH_PAGE_SETTINGS_MAILTEMPLATE',
  TSH_PAGE_SETTINGS_OTHERS = 'TSH_PAGE_SETTINGS_OTHERS',
  TSH_PAGE_SETTINGS_CHANNEL_LIST = 'TSH_PAGE_SETTINGS_CHANNEL_LIST',
  TSH_PAGE_SETTINGS_CHANNEL_NEW = 'TSH_PAGE_SETTINGS_CHANNEL_NEW',
  TSH_PAGE_SETTINGS_CHANNEL_EDIT = 'TSH_PAGE_SETTINGS_CHANNEL_EDIT',
  TSH_PAGE_SETTINGS_PRODUCTS_LIST = 'TSH_PAGE_SETTINGS_PRODUCTS_LIST',
  TSH_PAGE_SETTINGS_ADDITIONALSERVICES_LIST = 'TSH_PAGE_SETTINGS_ADDITIONALSERVICES_LIST',
  TSH_PAGE_SETTINGS_RATES_LIST = 'TSH_PAGE_SETTINGS_RATES_LIST',
  TSH_PAGE_SETTINGS_RATE_EDIT = 'TSH_PAGE_SETTINGS_RATE_EDIT',
  TSH_PAGE_SETTINGS_RATE_NEW_BASIC = 'TSH_PAGE_SETTINGS_RATE_NEW_BASIC',
  TSH_PAGE_SETTINGS_RATE_NEW_DERIVED = 'TSH_PAGE_SETTINGS_RATE_NEW_DERIVED',
  TSH_PAGE_SETTINGS_RATE_NEW_STATIC = 'TSH_PAGE_SETTINGS_RATE_NEW_STATIC',
  TSH_PAGE_SETTINGS_PROPERTY_EDIT = 'TSH_PAGE_SETTINGS_PROPERTY_EDIT',
  TSH_PAGE_SETTINGS_ACCOUNTINGEXPORT = 'TSH_PAGE_SETTINGS_ACCOUNTINGEXPORT',
  TSH_PAGE_SETTINGS_PAYMENTSACTIVE = 'TSH_PAGE_SETTINGS_PAYMENTSACTIVE',
  TSH_PAGE_SETTINGS_CASHDESKTYPES_LIST = 'TSH_PAGE_SETTINGS_CASHDESKTYPES_LIST',
  TSH_PAGE_SETTINGS_CASHDESKTYPES_EDIT = 'TSH_PAGE_SETTINGS_CASHDESKTYPES_EDIT',
  TSH_PAGE_SETTINGS_CASHDESKTYPES_NEW = 'TSH_PAGE_SETTINGS_CASHDESKTYPES_NEW',
  TSH_PAGE_SETTINGS_ROOMTETRIS = 'TSH_PAGE_SETTINGS_ROOMTETRIS',
  TSH_PAGE_CUSTOMERS = 'TSH_PAGE_CUSTOMERS',
  TSH_PAGE_CUSTOMERS_NEW_PERSON = 'TSH_PAGE_CUSTOMERS_NEW_PERSON',
  TSH_PAGE_CUSTOMERS_NEW_COMPANY = 'TSH_PAGE_CUSTOMERS_NEW_COMPANY',
  TSH_PAGE_RESERVATIONS_LIST = 'TSH_PAGE_RESERVATIONS_LIST',
  TSH_PAGE_PLANNING = 'TSH_PAGE_PLANNING',
  TSH_PAGE_PLANNING_HOURLY = 'TSH_PAGE_PLANNING_HOURLY',
  TSH_PAGE_PRICECALENDAR = 'TSH_PAGE_PRICECALENDAR',
  TSH_PAGE_DOCUMENTS = 'TSH_PAGE_DOCUMENTS',
  TSH_PAGE_POS = 'TSH_PAGE_POS',
  TSH_PAGE_QUOTES_LIST = 'TSH_PAGE_QUOTES_LIST',
  TSH_PAGE_QUOTE_NEW = 'TSH_PAGE_QUOTE_NEW',
  TSH_PAGE_QUOTE_EDIT = 'TSH_PAGE_QUOTE_EDIT',
  TSH_PAGE_SINAPSI = 'TSH_PAGE_SINAPSI',
  TSH_PAGE_SUPPORT = 'TSH_PAGE_SUPPORT',
  TSH_PAGE_BILLS = 'TSH_PAGE_BILLS',
  TSH_PAGE_SETTINGS_PLANNING = 'TSH_PAGE_SETTINGS_PLANNING',
  TSH_PAGE_MESSAGES = 'TSH_PAGE_MESSAGES',
}
